import script from "./jymp.vue?vue&type=script&setup=true&lang=js"
export * from "./jymp.vue?vue&type=script&setup=true&lang=js"

import "./jymp.vue?vue&type=style&index=0&id=374501d6&scoped=scoped&lang=css"

import exportComponent from "D:\\D盘\\桌面\\项目\\王者荣耀后台管理系统\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374501d6"]])

export default __exports__